import { useUpdate } from "ra-core";

import type { MessageTemplate } from "../types";
import { MessageTemplateDialog } from "./MessageTemplateDialog";

type MessageTemplateEditProps = {
  template: MessageTemplate;
  open: boolean;
  onClose(): void;
};

export function MessageTemplateEdit({
  template,
  open,
  onClose,
}: MessageTemplateEditProps) {
  const [update] = useUpdate<MessageTemplate>();

  const handleEdit = async (
    data: Pick<MessageTemplate, "name" | "body" | "channel">,
  ) => {
    await update("messageTemplates", {
      id: template.id,
      data: { ...data, updated_at: new Date().toISOString() },
      previousData: template,
    });
  };

  return (
    <MessageTemplateDialog
      open={open}
      title="Edit template"
      onClose={onClose}
      onSubmit={handleEdit}
      template={template}
    />
  );
}
